import utils from '@/utils';
import { clone, buildApiQuery } from '@/utils/dataUtil';
import { PPA_REF_API } from '@/api';
import { getMomentDateString } from '@/utils/dateUtil';

const state = {
  tableKey: -999,
  currentTableRow: null,
  tableData: [],
  ppaList: [],
  nullTableRow: {
    id: -999,
    ppaId: null,
    ppaName: null,
    bdName: null,
    startDate: null,
    endDate: null,
    val: null,
    month: null,
    hour: null,
    createdBy: null,
    createdDate: null,
    resource: null,
    updatedBy: null,
    updatedDate: null,
  },
};

const getters = {
  getPPAList: (state) => state.ppaList.map(({ id, name }) => ({ value: id, label: name })),
};

const actions = {
  initialize({ commit, dispatch, state }) {
    dispatch('fetchPPAList');
  },
  async fetchSettlementRefData({ commit }, parameters = {}) {
    const params = {
      contracts: parameters.ppasSelected,
    };
    try {
      const { data: { data } } = await PPA_REF_API.post('/settlement-ref/get', params);
      if (Array.isArray(data)) {
        data.forEach((obj) => {
          obj.startDate = getMomentDateString(obj.startDate);
          obj.endDate = obj.endDate === null ? null : getMomentDateString(obj.endDate);
        });
        commit('setTableData', data);
      }
      console.log('returned data:', data);
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Settlement Ref Data', 'error');
    }
  },
  fetchPPAList({ commit }) {
    PPA_REF_API.get('/ppa').then(({ data }) => {
      commit('loadPPAList', data.data);
    }).catch((err) => {
      console.error(err);
    });
  },
  postRecord({ state }, record) {
    // eslint-disable-next-line prefer-destructuring
    record.startDate = getMomentDateString(record.startDate);
    record.endDate = record.endDate === null ? null : getMomentDateString(record.endDate);

    PPA_REF_API.post('/settlement-ref', record).then(({ data }) => {
      data.startDate = getMomentDateString(data.startDate);
      data.endDate = data.endDate === null ? null : getMomentDateString(data.endDate);
      data.valueFormat = record.valueFormat;

      state.tableData.push(data);
      this.$notify('Data Added', 'success');
    }).catch((err) => {
      if (err.response.data === 'Reference data already exists') {
        this.$notify('Failed to Add Data. Data already exists', 'error');
      } else {
        this.$notify('Failed to Add Data', 'error');
      }
    });
  },
  updateRecord({ dispatch, commit, state }, record) {
    // eslint-disable-next-line prefer-destructuring
    record.startDate = getMomentDateString(record.startDate);
    record.endDate = record.endDate === null ? null : getMomentDateString(record.endDate);

    PPA_REF_API.put(`/settlement-ref/${record.id}`, record).then(({ data }) => {
      data.startDate = getMomentDateString(data.startDate);
      data.endDate = data.endDate === null ? null : getMomentDateString(data.endDate);
      data.valueFormat = record.valueFormat;

      commit('updateRecord', data);
      this.$notify('Data Updated', 'success');
    }).catch((err) => {
      this.$notify('Failed to Update Data', 'error');
    });
  },
  deleteTableRow({ dispatch, commit, state }) {
    PPA_REF_API.delete(`/settlement-ref/${state.currentTableRow.id}`).then(({ data }) => {
      commit('deleteTableRow');
      dispatch('currentTableRowChange', clone(state.nullTableRow));
      this.$notify('Data Removed', 'success');
    }).catch((err) => {
      this.$notify('Failed to Remove Data', 'error');
    });
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  updateRecord(state, record) {
    const rowIndex = state.tableData.findIndex(({ id }) => id === record.id);
    state.tableData.splice(rowIndex, 1, record);
  },
  currentTableRowChange(state, currentRow) {
    state.currentTableRow = currentRow;
  },
  reset(state) {
    state.tableData = [];
  },
  loadPPAList(state, pList) {
    state.ppaList = pList;
  },
  createTableRow(state) {
    const record = clone(state.nullTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },
  copyTableRow(state) {
    const record = clone(state.currentTableRow);
    record.id = state.tableKey++;
    record.versionId = 1;
    record.createdBy = this.getters['auth/getProfile'].userName;
    record.createdDate = utils.date.getNow().utc().format();
    state.currentTableRow = record;
  },
  deleteTableRow(state) {
    state.tableData = state.tableData.filter((record) => record.id !== state.currentTableRow.id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};